<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Experience(s)</h4>
    </div>
    <div
      class="card grey-card"
      v-for="(item, i) in experience_list"
      :key="i"
    >
      <v-row>
        <v-col md="11" sm="10" cols="10">
          <v-row>
            <v-col md="6" cols="6">
              <v-text-field
                v-model="experience_list[i].experience_year"
                type="number"
                label="Experience year(s)"
                outlined
                dense
              />
            </v-col>
            <v-col md="6" cols="6">
              <v-text-field
                v-model="experience_list[i].experience_month"
                type="number"
                label="Experience month(s)"
                outlined
                dense
              />
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="experience_list[i].detail"
                label="Experience detail"
                outlined
                dense
              />
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="experience_list[i].employer_nationality"
                label="Employer"
                outlined
                dense
              />
            </v-col>
            <v-col md="4" cols="6">
              <v-text-field
                v-model="experience_list[i].start_date"
                label="Start date"
                outlined
                dense
              />
            </v-col>
            <v-col md="4" cols="6">
              <v-text-field
                v-model="experience_list[i].end_date"
                label="End date"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col md="1" sm="2" cols="2">
          <v-btn
            @click="removeExperience(i)"
            small
            text
            color="red"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn
      @click="addExperience()"
      small
    >
      Add experience
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'SupporterExperience',
  props: ['experience_list', 'remove_experiences'],
  methods: {
    addExperience () {
      this.experience_list.push({ detail: '', employer_nationality: '', experience_year: null, experience_month: null, start_date: '', end_date: '' })
    },
    removeExperience (index) {
      if (this.experience_list[index].id)
        this.remove_experiences.push(this.experience_list[index].id)
      this.experience_list.splice(index, 1)
    }
  },
}
</script>